<script>
  export function reload() {
 //   load(0);
  }

</script>

<div class="scrollable-table orders-scrollable-table">
  <table style="margin-top: 0;">
    <thead>
      <tr class="flex flex-row align-center" style="padding-bottom: 0;">
        <th class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx0" class="css-checkbox select-cbx" type="checkbox" name="rowcbx0" />
            <label for="rowcbx0" class="css-label">&nbsp;</label>
          </div>
        </th>
        <th class="flex-none"><a>Invoice No</a></th>
        <th class="flex-1"><a>Customer</a></th>
        <th class="flex-none"><a>Total</a></th>
        <th class="flex-none"><a>Status</a></th>
        <th class="flex-none"><a>Pay Date</a></th>
        <th class="flex-none"><a>Payment</a></th>
        <th class="flex-none"><a>Payment Link</a></th>
      </tr>
    </thead>
    <tbody style="min-height: 500px;">
      <tr class="flex flex-row align-center" data-id="10">
        <td class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx10" class="css-checkbox select-cbx" type="checkbox" name="rowcbx10" /> <label for="rowcbx10" class="css-label">&nbsp;</label>
          </div>
        </td>
        <td class="flex-none"><a>1</a></td>
        <td class="flex-1"
          ><a rel="tab" href="/me/store/order-new"
            >Stan <br />
            <p class="table-support-text">stan@simvoly.com</p>
          </a></td>
        <td class="flex-none" style="font-size: 15px;">$199.00</td>
        <td class="flex-none"><span class="pay-status not-paid">Sent</span></td>
        <td class="flex-none">-</td>
        <td class="flex-none">-</td>
        <td class="flex-none"><span class="material-icons-outlined circle-effect table-circle-button"> link </span></td>
      </tr>
      <tr class="flex flex-row align-center" data-id="10">
        <td class="checkbox-table">
          <div class="checkbox-wrapper small">
            <input id="rowcbx10" class="css-checkbox select-cbx" type="checkbox" name="rowcbx10" /> <label for="rowcbx10" class="css-label">&nbsp;</label>
          </div>
        </td>
        <td class="flex-none"><a>1</a></td>
        <td class="flex-1"
          ><a rel="tab" href="/me/store/order-new"
            >Stan <br />
            <p class="table-support-text">stan@simvoly.com</p>
          </a></td>
        <td class="flex-none" style="font-size: 15px;">$199.00</td>
        <td class="flex-none"><span class="pay-status paid">Paid</span></td>
        <td class="flex-none"
          >May 25, 2020 <br />
          <p class="table-support-text">11:32</p>
        </td>
        <td class="flex-none">Stripe</td>
        <td class="flex-none"><span class="material-icons-outlined circle-effect table-circle-button"> link </span></td>
      </tr>
    </tbody>
  </table>
</div>
